import { Auth, Storage } from 'aws-amplify';
import API from '../api-graphql';
import APIUruk from '../api-rest-uruk';
import { store } from '../store';
import { CONSTANTS } from '../constants/constants';

export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SET_FILTER = 'SET_FILTER';
export const GET_MORE_BUNDLES = 'GET_MORE_BUNDLES';
export const GET_MORE_DOCUMENTS = 'GET_MORE_DOCUMENTS';
export const GET_MORE_TEMPLATES = 'GET_MORE_TEMPLATES';
export const GET_MORE_IDENTITIES = 'GET_MORE_IDENTITIES';
export const GET_ALL_BUNDLES = 'GET_ALL_BUNDLES';
export const GET_ALL_DOCUMENTS = 'GET_ALL_DOCUMENTS';
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';
export const GET_ALL_IDENTITIES = 'GET_ALL_IDENTITIES';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const CLEAN_STATE = 'CLEAN_STATE';
export const SET_SIGNER_USER = 'SET_SIGNER_USER';
export const SET_BATCH_TOKENS_BY_INDEX = 'SET_BATCH_TOKENS_BY_INDEX';
export const CLEAN_BATCH_TOKENS = 'CLEAN_BATCH_TOKENS';
export const UPDATE_LIST_DOCUMENT = 'UPDATE_LIST_DOCUMENT';
export const UPDATE_LIST_BUNDLES = 'UPDATE_LIST_BUNDLES';

export const saveConfig = (payload) => ({ type: SAVE_CONFIG, payload });
export const setFilter = (payload) => ({ type: SET_FILTER, payload });
export const cleanState = (payload) => ({ type: CLEAN_STATE, payload });
export const setMoreTemplates = (payload) => ({ type: GET_MORE_TEMPLATES, payload });
export const setTemplates = (payload) => ({ type: GET_ALL_TEMPLATES, payload });
export const setMoreDocuments = (payload) => ({ type: GET_MORE_DOCUMENTS, payload });
export const setDocuments = (payload) => ({ type: GET_ALL_DOCUMENTS, payload });
export const setMoreBundles = (payload) => ({ type: GET_MORE_BUNDLES, payload });
export const setBundles = (payload) => ({ type: GET_ALL_BUNDLES, payload });
export const setMoreIdentities = (payload) => ({ type: GET_MORE_IDENTITIES, payload });
export const setIdentities = (payload) => ({ type: GET_ALL_IDENTITIES, payload });
export const setSignerUser = (payload) => ({ type: SET_SIGNER_USER, payload });
export const setBatchTokensByIndex = (payload) => ({ type: SET_BATCH_TOKENS_BY_INDEX, payload });
export const cleanBatchTokens = (payload) => ({ type: CLEAN_BATCH_TOKENS, payload });
export const updateListDocument = (payload) => ({ type: UPDATE_LIST_DOCUMENT, payload });

const orderTabs = (tabs) => {
  return tabs.sort(({ order: aOrder }, { order: bOrder }) => aOrder - bOrder);
};

const parseFilters = (filters, subgroup, deletedStatus = 'deleted') => {
  const filterStatus = { status: { ne: deletedStatus } };
  const subgroupFilter = subgroup && subgroup.length ? { subgroups: { contains: subgroup } } : null;
  const dateFilter = filters.date && filters.date.length ? { createdAt: { ge: filters.date } } : null;
  const textFilter = filters.text && filters.text.length ? { searchField: { contains: filters.text } } : null;
  if (filters.status) {
    filterStatus.status.eq = filters.status;
  }
  return [filterStatus, dateFilter, textFilter, subgroupFilter]
    .filter(Boolean)
    .reduce((acc, filter) => ({ ...acc, ...filter }), {});
};

const parseFiltersForDocuments = (filters, subgroup, type, status, owner) => {
  const filter = parseFilters(filters, subgroup);

  if (type) {
    filter.type = { eq: type };
  }

  if (status && !filter.status.eq) {
    filter.status.in = status;
  }

  if (owner) {
    filter.owner = { eq: owner };
  }

  return filter;
};

export const saveSignerUser = (user) => {
  return async (dispatch) => {
    dispatch(setSignerUser(user));
    return user;
  };
};

export const getConfig = (user, newGroup, newSubgroup, newRole) => {
  return async dispatch => {
    try {
      if (newGroup && newSubgroup) {
        await Auth.updateUserAttributes(user, { 'custom:group': newGroup, 'custom:subgroup': newSubgroup, 'custom:role': newRole });
        user.attributes && user.attributes.preferred_username && (user.username = user.attributes.preferred_username);
      }

      let group = user.signInUserSession.idToken.payload.group;
      let subgroup = user.signInUserSession.idToken.payload.subgroup;
      let role = user.signInUserSession.idToken.payload.role;
      const configId = user.signInUserSession.idToken.payload.configId;
      const roleId = user.signInUserSession.idToken.payload.roleId;

      const groups = JSON.parse(user.signInUserSession.idToken.payload.groups);
      const { context } = groups.find(({ context }) => context.name === subgroup);

      let config = await APIUruk.getApplication(configId);

      const { tabs } = config.roles.filter((role) => role.id === Number(roleId))[0] || config.roles[0];
      const orderedTabs = orderTabs(tabs);
      const visibleTabs = orderedTabs.map(({ tab }) => tab);

      if (config.theme) {
        const { theme: { logo: configLogo } } = config;
        if (configLogo) {
          config.theme.logo = configLogo && configLogo.startsWith('http') ? configLogo : await Storage.get(configLogo.replace('public/', ''));
        }
      }

      if (config.activeContext.theme && config.activeContext.theme.logo) {
        const { theme: { logo: contextLogo } } = config.activeContext;
        if (contextLogo) {
          config.theme.logo = contextLogo && contextLogo.startsWith('http') ? contextLogo : await Storage.get(contextLogo.replace('public/', ''));
        }
      }

      config = {
        ...config,
        visibleTabs,
        group,
        subgroup,
        role,
        groups,
        user,
        context
      };

      dispatch(saveConfig(config));
      return config;
    } catch (err) {
      console.error(err);
      await Auth.signOut();
    }
  };
};
export const getDocuments = ({ currentPath = null, nextToken = null, abortSignal = null } = {}) => {
  return async (_, getState) => {
    const pathArray = currentPath ? currentPath.split('/') : window.location.href.split('/');
    let path;

    let filter;

    if (pathArray.includes('detail') && pathArray.includes('document')) {
      path = 'document';
    } else {
      path = pathArray[pathArray.length - 1];
    }

    switch (path) {
      case 'finished': {
        const docType = 'document';
        const statusList = [CONSTANTS.FLOW.STATUS.SIGNED, CONSTANTS.FLOW.STATUS.CANCELLED, CONSTANTS.FLOW.STATUS.EXPIRED];
        const { filter: { finished: filters = {}, owner }, config: { subgroup } } = getState();
        filter = parseFiltersForDocuments(filters, subgroup, docType, statusList, owner);
        break;
      }
      case 'document': {
        const docType = 'document';
        const statusList = [CONSTANTS.FLOW.STATUS.INIT, CONSTANTS.FLOW.STATUS.SEND_TO_SIGN, CONSTANTS.FLOW.STATUS.REJECTED, CONSTANTS.FLOW.STATUS.ERROR];
        const { filter: { pending: filters = {}, owner }, config: { subgroup } } = getState();
        filter = parseFiltersForDocuments(filters, subgroup, docType, statusList, owner);
        break;
      }
      case 'file': {
        const docType = 'file';
        const { filter: { files: filters = {} }, config: { subgroup } } = getState();
        filter = parseFiltersForDocuments(filters, subgroup, docType);
        break;
      }
      case 'notification': {
        const docType = 'notification';
        const { filter: { certifiedNotification: filters = {} }, config: { subgroup } } = getState();
        filter = parseFiltersForDocuments(filters, subgroup, docType);
        break;
      }
      default:
        return [];
    }
    const [result, newNextToken] = await API.listDocuments(filter, nextToken, abortSignal);
    return [result, newNextToken];
  };
};

export const updateListDocuments = ({ newItemUpdated }) => {
  return async (dispatch, getState) => {
    const itemFromState = [...getState().documents.documents];
    const itemsUpdated = [];

    itemFromState.forEach(item => {
      if (item.flowId === newItemUpdated.flowId) {
        const removeItem = [CONSTANTS.FLOW.STATUS.SIGNED, CONSTANTS.FLOW.STATUS.CANCELLED, CONSTANTS.DOCUMENT.STATUS.DELETED].includes(newItemUpdated.status);

        if (removeItem && item.type === 'document') {
          return;
        } else if (typeof newItemUpdated.flow === 'string' && newItemUpdated.flow.length) {
          item.flow = newItemUpdated.flow;
        } else if (typeof newItemUpdated === 'object') {
          const oldFlow = JSON.parse(item.flow);
          item.flow = JSON.stringify({ ...oldFlow, ...newItemUpdated });
        }
      }
      itemsUpdated.push(item);
    });
    dispatch(updateListDocument(itemsUpdated));
  };
};

export const getTemplates = () => {
  return async (dispatch, getState) => {
    const { filter: { templates: filters = {} }, config: { subgroup } } = getState();
    const filter = parseFilters(filters, subgroup);
    const result = await API.listTemplates(filter);
    dispatch(setTemplates(result.data.listTemplates));
    return result;
  };
};

export const updateListBundles = ({ newItemUpdated }) => {
  return async (dispatch, getState) => {
    const itemFromState = [...getState().documents.documents];
    const updateLocalStatus = [CONSTANTS.BUNDLE.STATUS.DELETED].includes(newItemUpdated.bundle.status);

    if (updateLocalStatus) {
      const itemsUpdated = itemFromState.filter(item => item.id !== newItemUpdated.bundle.id);
      return dispatch(updateListDocument(itemsUpdated));
    }

    if (!newItemUpdated.flow) {
      const itemsUpdated = itemFromState.map(item => {
        if (item.id === newItemUpdated.bundle.id) {
          const newBundleUpdate = { ...item, ...newItemUpdated.bundle };
          return newBundleUpdate;
        }
        return item;
      });
      return dispatch(updateListDocument(itemsUpdated));
    } else {
      const itemsUpdated = itemFromState.map(item => {
        if (item.flowId === newItemUpdated.flow.flowId) {
          item.flow = newItemUpdated.flow.flowStringfy;
          item.status = newItemUpdated.bundle.status;
          return item;
        }
        if (item.id === newItemUpdated.bundle.id) {
          const newBundleUpdate = {
            ...item,
            flow: newItemUpdated.flow.flowStringfy,
            flowId: newItemUpdated.flow.flowId,
            status: newItemUpdated.bundle.status
          };
          return newBundleUpdate;
        }
        return item;
      });
      return dispatch(updateListDocument(itemsUpdated));
    }
  };
};

export const getBundles = ({ nextToken = null, searchByDocument = false, abortSignal = null } = {}) => {
  return async (_, getState) => {
    const { filter: { bundle: filters = {} }, config: { subgroup } } = getState();
    let filter = parseFilters(filters, subgroup);

    if (searchByDocument) {
      filter = {
        status: { ne: 'deleted' },
        filterDoc: filter
      };
    }

    const [result, newNextToken] = await API.listBundles(filter, nextToken, searchByDocument, abortSignal);
    if (searchByDocument && result && result.data && result.data.listBundles) {
      result.data.listBundles.items = result.data.listBundles.items.filter(bundle =>
        bundle.document && bundle.document.items && bundle.document.items.length > 0
      );
    }
    return [result, newNextToken];
  };
};

export const getSignerDocuments = ({ search, nextToken, filterByWaitingForMe }) => {
  return async (_, getState) => {
    let [result, newNextToken] = await API.listDocumentsByEmail(search, nextToken);

    if (filterByWaitingForMe) {
      const _filteredDocuments = result.data.listDocumentsByEmail.items.filter((document) => {
        const flow = JSON.parse(document.document.flow);
        if (!flow) return false;

        const stepToSign = flow.steps.some((step, index) => {
          if (step.status === CONSTANTS.STEP.STATUS.SEND_TO_SIGN && !step.automatic && flow.steps[index - 1].emails.includes(getState().user.attributes.email)) {
            return true;
          }
        });
        return stepToSign;
      });
      result.data.listDocumentsByEmail.items = _filteredDocuments;
    }
    return [result, newNextToken];
  };
};

export const getIdentities = () => {
  return async (dispatch, getState) => {
    const { filter: { identity: filters }, config: { subgroup } } = getState();
    const arrFilter = () => filters && filters.length ? filters.map(filter => (
      { searchField: { contains: filter }
      })) : [];
    const objFilter = { and: arrFilter() };
    const filter = objFilter.and.length ? objFilter : null;
    const result = await API.listUsers(filter, subgroup, null);
    dispatch(setIdentities(result.data.listUsers));
    return result;
  };
};

export const getMoreIdentities = (search) => {
  const state = store.getState();
  return async dispatch => {
    if (state.documents.nextToken) {
      const result = await API.listDocuments(search, state.config.subgroup, state.identity.nextToken);
      dispatch(setMoreDocuments(result.data.listDocuments));
      return result;
    }
  };
};
